<template>
  <div class="pagina-upload">

    <!-- Título -->
    <div class="header">
      <h2>Envie sua foto</h2>
      <p>Tire a foto e confirme o envio</p>
    </div>

    <!-- Preview -->
    <div class="preview-area">
      <img
          v-if="previewFoto"
          :src="previewFoto"
          class="preview-img"
      />
      <div v-else class="placeholder" @click="abrirCamera">
        <v-icon large>camera_alt</v-icon>
        <label>Toque aqui para tirar a foto</label>
      </div>
    </div>

    <!-- Botão principal -->
    <div class="footer">
      <v-btn
          v-if="!arquivo"
          block
          large
          color="primary"
          class="botao-principal"
          @click="abrirCamera"
      >
        Tirar Foto
      </v-btn>

      <v-btn
          v-if="arquivo"
          block
          large
          :disabled="enviando || desativarEnvioDuplo"
          color="success"
          class="botao-principal"
          @click="enviarArquivo"
      >
        Enviar
      </v-btn>

      <v-btn
          v-if="arquivo"
          block
          text
          class="mt-2"
          @click="resetar"
      >
        Tirar outra
      </v-btn>
    </div>

    <!-- Input invisível -->
    <input
        ref="fileInput"
        type="file"
        accept="image/*"
        capture="environment"
        class="input-hidden"
        @change="selecionarArquivo"
    />

  </div>
</template>

<script>
import {actionTypes} from '@/core/constants'

export default {
    name: 'EnviarFotoPorQRCodePaciente',
    data() {
        return {
            token: null,
            arquivo: null,
            previewFoto: null,
            enviando: false,
            desativarEnvioDuplo: false,
            usarCompressao: true,
            larguraMaxima: 1280,
            qualidadeImagem: 0.8
        }
    },
    mounted() {
        this.setarToken()
        setTimeout(() => {
            this.abrirCamera()
        }, 500)
    },
    methods: {
        setarToken() {
            if (this.$route.params.token) {
                this.token = this.$route.params.token
            }
        },
        abrirCamera() {
            this.$refs.fileInput.click()
        },
        async selecionarArquivo(event) {
            const file = event.target.files[0]
            if (!file) return

            if (!file.type.startsWith('image/')) {
                alert('Envie apenas imagens.')
                return
            }

            let arquivoFinal = file

            if (this.usarCompressao) {
                console.log('Tamanho Original:', file.size)
                arquivoFinal = await this.comprimirImagem(file)
                console.log('Tamanho Comprimido:', arquivoFinal.size)
            }

            this.arquivo = arquivoFinal
            this.previewFoto = URL.createObjectURL(arquivoFinal)
        },
        comprimirImagem(file) {
            return new Promise((resolve, reject) => {

                const img = new Image()
                const reader = new FileReader()

                reader.readAsDataURL(file)

                reader.onload = event => {
                    img.src = event.target.result
                }

                img.onload = () => {

                    let largura = img.width
                    let altura = img.height

                    if (largura > this.larguraMaxima) {
                        altura *= this.larguraMaxima / largura
                        largura = this.larguraMaxima
                    }

                    const canvas = document.createElement('canvas')
                    const ctx = canvas.getContext('2d')

                    canvas.width = largura
                    canvas.height = altura

                    ctx.drawImage(img, 0, 0, largura, altura)

                    canvas.toBlob(
                        blob => {
                            if (!blob) {
                                reject(new Error('Erro na compressão'))
                                return
                            }

                            const arquivoComprimido = new File(
                                [blob],
                                file.name,
                                {
                                    type: 'image/jpeg',
                                    lastModified: Date.now()
                                }
                            )

                            resolve(arquivoComprimido)
                        },
                        'image/jpeg',
                        this.qualidadeImagem
                    )
                }

                img.onerror = error => reject(error)
            })
        },
        resetar() {
            this.arquivo = null
            this.previewFoto = null
            this.desativarEnvioDuplo = false
            this.$refs.fileInput.value = null
            this.abrirCamera()
        },
        async enviarArquivo() {

            if (!this.token) {
                this.mostrarNotificacaoErro('Não foi possível identificar o token!')
                return
            }
            if (!this.arquivo) {
                this.mostrarNotificacaoErro('Realize o upload do arquivo!')
                return
            }

            this.enviando = true
            this.desativarEnvioDuplo = true

            const input = {
                token: this.token,
                arquivo: this.arquivo
            }
            await this.$store.dispatch(actionTypes.GALERIA_PACIENTE.ENVIAR_MIDIA_PUBLIC_TOKEN, input)
            this.mostrarNotificacaoSucesso('Foto enviada com sucesso!')
            this.enviando = false
        }
    }
}
</script>

<style scoped lang="stylus">
.pagina-upload
  min-height 100vh
  display flex
  flex-direction column
  background #f7f7f7

.header
  padding 10px 16px 0
  text-align center

  h2
    margin 0
    font-size 20px

  p
    margin-top 6px
    font-size 14px
    color #666

.preview-area
  flex 1
  display flex
  justify-content center
  align-items center
  padding 5px 16px

.preview-img
  width 100%
  max-width 400px
  border-radius 16px
  box-shadow 0 10px 30px rgba(0, 0, 0, .2)

.placeholder
  color #999
  font-size 14px
  display flex
  flex-direction column
  align-items center
  justify-content center

.placeholder:hover
  cursor pointer

.footer
  padding 16px
  background white
  box-shadow 0 -5px 15px rgba(0, 0, 0, .05)

.botao-principal
  height 56px
  font-size 16px
  border-radius 14px

.input-hidden
  display none
</style>